import { useState } from "react";

import { Box, IconButton, Tooltip, Typography } from "@material-ui/core";
import HistoryIcon from "@mui/icons-material/History";
import VisibilityIcon from "@mui/icons-material/Visibility";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField } from "utils/tables-utils";
import themeColorsDesingSystem from "assets/theme/ds-colors";

import DialogDetalheImportacao from "./DialogDetalheImportacao";

export default function TableHistoricoImportacao({ data, searching }) {
  const [selectedItem, setSelectedItem] = useState(null);

  function handleOpenDetails(row) {
    setSelectedItem(row);
  }

  function handleCloseDetails() {
    setSelectedItem(null);
  }

  function ActionsFormatter(_, row) {
    return (
      <Tooltip title="Ver detalhes">
        <IconButton
          size="small"
          color="primary"
          onClick={() => handleOpenDetails(row)}
          aria-label="Ver detalhes da importação"
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    );
  }

  const columnModel = [
    columnTextField(
      {
        dataField: "dataAlteracao",
        text: "Data",
        align: "center",
      },
      false,
    ),
    columnTextField(
      {
        dataField: "nome",
        text: "Usuário",
        align: "center",
      },
      false,
    ),
    columnTextField(
      {
        dataField: "statusProcesso",
        text: "Status",
        align: "center",
      },
      false,
    ),

    columnTextField(
      {
        dataField: "acoes",
        text: "Ações",
        align: "center",
        formatter: ActionsFormatter,
      },
      false,
    ),
  ];

  return (
    <Box mt={4}>
      <Box display="flex" alignItems="center" mb={2}>
        <HistoryIcon
          style={{
            color: themeColorsDesingSystem.primary.main,
            marginRight: 8,
          }}
        />
        <Typography
          variant="h3"
          style={{
            color: themeColorsDesingSystem.primary.main,
            fontWeight: 700,
          }}
        >
          Histórico de importações
        </Typography>
      </Box>

      <ToolkitTable
        dataTable={data}
        searched={!searching}
        keyField="idRepresentanteCidadeImportacaoLog"
        columnModel={columnModel}
        notFoundTitle="Nenhum histórico de importação encontrado."
      />

      <DialogDetalheImportacao
        open={Boolean(selectedItem)}
        item={selectedItem}
        onClose={handleCloseDetails}
      />
    </Box>
  );
}
